import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

interface Branch {
  id: number;
  city: string;
}

interface RegisterModalProps {
  show: boolean;
  onHide: () => void;
}

function RegisterModal({ show, onHide }: RegisterModalProps) {
  const [branches, setBranches] = useState<Branch[]>([]);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [selectedBranchId, setSelectedBranchId] = useState<number | null>(null);

  useEffect(() => {
    // You may trigger this modal manually, or keep this for auto-popup:
    // setTimeout(() => handleShow(), 3000);
  }, []);

  useEffect(() => {
    fetch('https://strapi-production-a706.up.railway.app/api/branches?sort=order:ASC')
      .then((res) => res.json())
      .then((data) => setBranches(data.data))
      .catch((err) => console.error('Failed to fetch branches:', err));
  }, []);

  const handleSubmit = async () => {
    if (!firstName || !lastName || !email || !phoneNumber || !selectedBranchId) {
      toast.info('Ju lutem plotësoni të gjitha fushat!');
      return;
    }

    try {
      const payload = {
        data: {
          email,
          firstName,
          lastName,
          phoneNumber,
          isContacted: false,
          filialet: selectedBranchId,
        },
      };

      const res = await fetch('https://strapi-production-a706.up.railway.app/api/registers', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error('Request failed');

      toast.success(
        'Regjistrimi u krye me sukses! Se shpejti do kontaktoheni për grupin e rradhës',
      );
      onHide();
    } catch (err) {
      console.error('Failed to register:', err);
      toast.error('Ndodhi një gabim gjatë regjistrimit!');
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Regjistrohu në grupin e rradhës</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mb-2">
          <div className="col-md-10 mx-auto">
            <input
              type="text"
              className="form-control"
              placeholder="Emri"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-md-10 mx-auto">
            <input
              type="text"
              className="form-control"
              placeholder="Mbiemri"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-md-10 mx-auto">
            <input
              type="email"
              className="form-control"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-md-10 mx-auto">
            <input
              type="text"
              className="form-control"
              placeholder="Numri i telefonit"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-10 mx-auto">
            <select
              className="form-control"
              value={selectedBranchId ?? ''}
              onChange={(e) => setSelectedBranchId(Number(e.target.value))}
            >
              <option value="">Zgjidh Qytetin</option>
              {branches?.map((branch) => (
                <option key={branch.id} value={branch.id}>
                  {branch?.city}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="text-center">
          <button className="button button--secondary" onClick={handleSubmit}>
            <span>Regjistrohu</span>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default RegisterModal;
